import * as React from "react"
import { useState } from "react"
import { Link } from "gatsby"
import { StaticImage } from "gatsby-plugin-image"
import MenuLink from "./menuLink"
import MenuAll from "./menuAll"
import { Lang, LangCode, LangEnum } from "../utils/lang"
import { liteClient as algoliasearch } from 'algoliasearch/lite'
import { InstantSearch, SearchBox, Hits, Configure, Pagination, useInstantSearch } from 'react-instantsearch'

const searchClient = algoliasearch('7CFWDC4YY0', 'cf8e1900a591244ebac6da2c35c1bd65');

const Navigation = ({ config }) => {
  const version = process.env.NODE_ENV
  const lang = Lang()
  const langCode = LangCode()
  const reload = () => {
    fetch('/__refresh', {
      method: 'POST',
    })
    .then(response => {
      if (response.ok) {
        alert('Content Reloading... it takes about 30 seconds');
        window.location.reload();
      } else {
        console.error('Failed to refresh:', response.statusText);
      }
    })
    .catch(error => {
      console.error('Error occurred during refresh:', error);
    });
  };

  let menu = config.header_menu || []
  let language = config.language || []
  let searchIconSvg = lang === LangEnum.JA ? '/icons/search.svg' : '/icons/search-box.svg'
  // console.log(menu);
  // console.log(language);
  // const Nav = () => menu.map((blok, i) => MenuLink({ blok }))
  const [openMenu, setOpenMenu] = useState(false);
  const [isSearchOpen, setIsSearchOpen] = useState(false);

  const Hit = ({ hit }) => (
    <div className="p-2 hover:bg-gray-100">
      <a href={hit.url}>
        <h4 className="font-medium">{hit.title}</h4>
        {/* <p className="text-sm text-gray-600">{hit.description}</p> */}
      </a>
    </div>
  );

  const EmptyQueryBoundary =({ children, fallback }) => {
    const { indexUiState } = useInstantSearch();
    if (!indexUiState.query) {
      return (
        <>
          {fallback}
          <div hidden>{children}</div>
        </>
      );
    }
    return children;
  }

  return (
    <div className="relative bg-white border-b border-gray-100">
      { version === 'development' && 
      <button onClick={reload} className="float-right inline-block">
        <StaticImage className="" src="../images/refresh.svg" alt="refresh"/>
      </button>
      }

      <div className="max-w-7xl mx-auto px-4 sm:px-6">
        <div className="flex justify-between items-center pt-3 md:justify-start md:space-x-10">
          <div className="flex justify-start">
            <Link to={`${lang}/`}>
              <img className="h-auto w-40" src="/img/AMNET-LOGO.svg" alt="Amnet Logo" />
            </Link>
          </div>
          <div className="-mr-2 -my-2 md:hidden inline-flex">
            <button className="" onClick={() => setIsSearchOpen(true)}>
              <img className="" src={searchIconSvg} alt="search"/>
            </button>
            <button
              type="button"
              onClick={() => setOpenMenu(true)}
              className="bg-white rounded-md p-2 inline-flex items-center justify-center text-gray-400 hover:text-gray-500 hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-inset focus:ring-indigo-500"
              aria-expanded="false"
            >
              <span className="sr-only">Open menu</span>
              <svg
                className="h-6 w-6"
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
                aria-hidden="true"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  d="M4 6h16M4 12h16M4 18h16"
                />
              </svg>
            </button>
          </div>
          <div className="hidden md:flex items-center justify-center md:flex-1 lg:w-0">
            { menu.map((blok, i) => <MenuLink blok={blok} index={i} key={i}/>) }
            <MenuAll menu={menu} />
          </div>
          <div className="hidden md:flex items-center justify-end">
            <button onClick={() => setIsSearchOpen(true)}><img className="mt-4 mb-6 mr-3 hover:shadow" src={searchIconSvg} alt="search"/></button>

            <img className="mt-4 mb-6" src="/icons/header-globe.svg" alt="language"/>
            { language[0] && <MenuLink blok={language[0]} /> }
          </div>
        </div>
      </div>

      {isSearchOpen && (
        <>
          <div className="fixed inset-0 bg-black bg-opacity-70 z-40" onClick={() => setIsSearchOpen(false)}></div>
          <div className="absolute top-10 left-1/2 -translate-x-1/2 w-11/12 max-w-4xl bg-white rounded-lg p-4 z-50">
            <InstantSearch searchClient={searchClient} indexName="netlify_62218230-be23-4837-98a1-19f18013ce5b_master_all">
              <SearchBox 
                autoFocus={true}
                searchAsYouType={false}
                resetIconComponent={ () => (<></>)}
                classNames={{
                  form: 'flex w-full',
                  input: 'border border-gray-300 rounded-md h-8 w-full px-3 mr-2 text-sm',
                }}
              />
              <EmptyQueryBoundary fallback={<div className="pt-2">Type to search...</div>}>
                <Hits hitComponent={Hit} />
              </EmptyQueryBoundary>
              <Configure
                analytics={version != 'development'}
                filters={`lang:'${langCode}'`}
                hitsPerPage={10}
              />
              {/* 
              <Pagination
                classNames={{
                  list: 'flex justify-center',
                  item: 'mx-2',
                }}
              /> 
              */}
            </InstantSearch>
          </div>
        </>
      )}
      {/* <!--
      Mobile menu, show/hide based on mobile menu state.
    --> */}
      {openMenu && (
        <div className="absolute top-0 inset-x-0 p-2 transition transform origin-top-right md:hidden z-50">
          <div className="rounded-lg shadow-lg ring-1 ring-black ring-opacity-5 bg-white divide-y-2 divide-gray-50">
            <div className="pt-5 pb-6 px-5">
              <div className="flex items-center justify-between">
                <div>
                  <img className="h-8 w-auto" src="/img/AMNET-LOGO.svg" alt="Amnet Logo" />
                </div>
                <div className="-mr-2">
                  <button
                    type="button"
                    onClick={() => setOpenMenu(false)}
                    className="bg-white rounded-md p-2 inline-flex items-center justify-center text-gray-400 hover:text-gray-500 hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-inset focus:ring-indigo-500"
                  >
                    <span className="sr-only">Close menu</span>
                    {/* <!-- Heroicon name: outline/x --> */}
                    <svg
                      className="h-6 w-6"
                      xmlns="http://www.w3.org/2000/svg"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke="currentColor"
                      aria-hidden="true"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="2"
                        d="M6 18L18 6M6 6l12 12"
                      />
                    </svg>
                  </button>
                </div>
              </div>
              <div className="mt-6">
                <nav className="grid gap-y-8">
                  { menu.map((blok, i) => <MenuLink blok={blok} index={i} key={i} />) }
                  { language[0] && !language[0].hidden && 
                    <div className="flex"><img className="mt-4 mb-6" src="/icons/header-globe.svg" alt="language"/><MenuLink blok={language[0]} /></div> 
                  }
                </nav>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};
 
export default Navigation;